import { z } from 'zod';
import { rawString } from '../../Language/Language';

export const GiftEmailTaskSchema = z.object({
  email: z
    .string()
    .min(1, {
      message:
        rawString({ langKey: 'pdx.review.gift_email.required_error' }) ??
        'Email address is required',
    })
    .email({
      message:
        rawString({ langKey: 'pdx.review.gift_email.invalid_error' }) ??
        'Enter a valid email address',
    }),
});

export type GiftEmailData = {
  giftEmail: z.infer<typeof GiftEmailTaskSchema>;
};
